/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface ExecuteJobs$Params {
   providerId: string;
}

export function executeJobs(
   http: HttpClient,
   rootUrl: string,
   params: ExecuteJobs$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<void>> {
   const rb = new RequestBuilder(rootUrl, executeJobs.PATH, 'put');
   if (params) {
      rb.path('providerId', params.providerId, {});
   }

   return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
   );
}

executeJobs.PATH = '/api/weather/job/execution/{providerId}';
